/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { BaseDesignListComponent } from './components/base-design-list/base-design-list.component';
import { BaseDesignDetailsComponent } from './components/base-design-details/base-design-details.component';
import { BaseDesignBusinessService } from './resources';

const routes = [
  createRoute({
    component: BaseDesignListComponent,
    path: '',
    init: BaseDesignBusinessService,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
    },
  }),
  createRoute({
    component: BaseDesignDetailsComponent,
    path: ':baseDesignId',
    pathMatch: 'full',
    init: {
      service: BaseDesignBusinessService,
      selector: 'initDetailsView',
    },
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupBaseDesignRoutingModule {
}
